import { GetterTree } from 'vuex'
import { SnackState } from './snack.types'

export const getters: GetterTree<SnackState, unknown> = {
  snack(state) {
    return state.snack
  }
}
